const getOsCpu = (): string | undefined => {
    return navigator.oscpu
}

export default getOsCpu;